import styles from "../../../../components/TaskCard/TaskButton.module.scss";
import { FC, useCallback, useEffect, useState } from "react";
//import { vk } from 'vanilla-sharing';
import { useDispatch, useSelector } from "../../../../hooks";
import { VkShareTaskDto } from "./VkShareTask";
import { now } from "../../../../utils/time";
import { TaskCard } from "../../../../components/TaskCard/TaskCard";
import { getKeyByValue } from "../../../../utils/enums";
import { getRefLink } from "../../../../utils/links";
import { checkVkShareTask } from "../../../../redux/tasks/check-vk-share.handler";

interface IVkShareItemProps {
    task: VkShareTaskDto;
    index: number;
}

enum PerformTaskState {
    None = '',
    Check = 'Проверить',
    Pending = 'На проверке',
    Completed = 'Выполнено'
}

const initVk = () => {
    const VK = (window as any).VK;
    VK.init({
        apiId: +process.env.REACT_APP_VK_API_ID!,
        onlyWidgets: true
    });
}

export const VkShareItem: FC<IVkShareItemProps> = ({ task, index }) => {
    
    initVk();
    
    const getStageByDate = useCallback((): PerformTaskState => {        
        if (task.performDate + task.cooldown < now())
            return PerformTaskState.None;

        if (task.performDate + task.cooldown > now()) {
            if (task.pendingTime === 0)
                return PerformTaskState.Check;
            
            if (task.performDate + task.pendingTime > now())
                return PerformTaskState.Pending;
        }

        return PerformTaskState.Completed;
    }, [task.performDate, task.cooldown, task.pendingTime]);
    
    const [stage, setStage] = useState<PerformTaskState>(getStageByDate())

    const [/*refLink*/, setRefLink] = useState('');
    const userId = useSelector(store => store.user.info.id);
    const dispatch = useDispatch();

    useEffect(() => {
        const refLink = getRefLink(userId);
        setRefLink(refLink);
    }, [userId]);

    useEffect(() => {
        setStage(getStageByDate());
    }, [task.performDate, task.cooldown, task.pendingTime, getStageByDate]);

    const handleShareClick = () => {
        /*
        index.html
        <script src="https://vk.com/js/api/openapi.js?169" type="text/javascript"></script>
        */
        
        /*const shareObject = {
            url: task.link === '' ? `${task.description}\r\n${refLink}` : `${task.description}\r\n${task.link}`,
            title: task.title,
            description: task.description,
            image: task.image,
            isVkParse: false,
        };

        if (getDeviceType() !== DeviceType.iOS) {
            const shareUrl = `https://vk.com/share.php?url=${shareObject.description}\r\n${shareObject.url}&title=${shareObject.title}&description=${shareObject.description}&image=${shareObject.image}&noparse=${!shareObject.isVkParse}`;
            window.location.href = shareUrl;            
        }
        else {
            vk(shareObject);
        }*/

        //const VK = (window as any).VK;

        //VK.Widgets.Like('vk_like', {width: 500, pageTitle: task.title}, 1);
        //VK.Widgets.Like('vk_like');

        //dispatch(performVkShareTask(task.taskId));
    };

    const handleRewardClick = () => {
        if (stage !== PerformTaskState.Check)
            return;

        dispatch(checkVkShareTask(task.taskId));
    }

    const getPerformButton = () => {
        return (
            <>
                <button
                    className={`${styles.button} ${styles.perform}`}
                    onClick={ handleShareClick }
                    id='share-button'
                >
                    Поделиться 
                </button>

                <div id='vk_like' />
            </>
        );        
    }

    const getRewardButton = () => {
        return (
            <button
                className={`${styles.button} ${styles.reward} ${styles[getKeyByValue(PerformTaskState, stage)]}`}
                onClick={ handleRewardClick }
                id='reward-button'
            >
                { stage }
            </button>
        );        
    }

    return (
        <TaskCard
            key={ `vkShareTask${task.taskId}` }
            task={ task }
            index={ index }
            performButton={ getPerformButton() }
            rewardButton={ stage !== PerformTaskState.None ? getRewardButton() : null }
        />
    );
}